import classNames from "classnames";
import PropTypes from "prop-types";
import content from "app-content";
import styles from "./index.css";
import { ACCESS_LEVEL_VIEW } from "../../../../constants";

const EarlyAccessBadge = ({ customerAccess, earlyAccessBadge }) => {
  if (!customerAccess) {
    return null;
  }

  return (
    <div
      id={earlyAccessBadge}
      aria-hidden="true"
      className={classNames(styles.earlyAccessBadge, {
        [styles.comingSoon]: customerAccess === ACCESS_LEVEL_VIEW
      })}
    >
      {customerAccess === ACCESS_LEVEL_VIEW
        ? content.coming_soon_label
        : content.early_access_label}
    </div>
  );
};

EarlyAccessBadge.propTypes = {
  customerAccess: PropTypes.string,
  earlyAccessBadge: PropTypes.string.isRequired
};

export default EarlyAccessBadge;
